import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import _ from 'lodash';

import { reportAxiosError } from '../../Utils';

export const usePaymentsLimits = (claim, exposure, payableType, requestType, fetch = false) => {
  const [userExposureLimit, setUserExposureLimit] = useState(null);
  const [isUserExposureLimitLoading, setIsUserExposureLimitLoading] = useState(false);
  const [isUserExposureLimitError, setIsUserExposureLimitError] = useState(false);

  const fetchLimit = useCallback(async () => {
    const url = exposure.id
      ? `/api/v1/claims/${claim.id}/exposures/${exposure.id}/${payableType}/${requestType}/limit`
      : `/api/v1/claims/${claim.id}/general_expenses/${requestType}/limit`;
    try {
      setIsUserExposureLimitLoading(true);
      const response = await axios.get(url);
      setUserExposureLimit(response.data);
    } catch (error) {
      setIsUserExposureLimitError(true);
      await reportAxiosError(error);
    } finally {
      setIsUserExposureLimitLoading(false);
    }
  }, [claim, exposure, payableType, requestType]);

  useEffect(() => {
    // The error is scoped to one target: a failed fetch for a different
    // claim/exposure/payable must not keep blocking this one.
    setIsUserExposureLimitError(false);
  }, [fetchLimit]);

  useEffect(() => {
    if (fetch && _.isNil(userExposureLimit) && !isUserExposureLimitError) {
      fetchLimit();
    } else if (!fetch) {
      setUserExposureLimit(null);
      setIsUserExposureLimitError(false);
    }
  }, [fetchLimit, fetch, userExposureLimit, isUserExposureLimitError]);

  return { userExposureLimit, isUserExposureLimitLoading, isUserExposureLimitError };
};

export default usePaymentsLimits;
